const GCLID_STORAGE_KEY = 'gclid';

const getGclidFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('gclid') || '';
};

/**
 * Persist gclid from the URL on first touch so it survives browsing
 * before the user returns to checkout.
 */
export const captureGclid = () => {
  try {
    const urlGclid = getGclidFromUrl();
    if (!urlGclid) {
      return;
    }

    const storedGclid = localStorage.getItem(GCLID_STORAGE_KEY);
    if (!storedGclid) {
      localStorage.setItem(GCLID_STORAGE_KEY, urlGclid);
    }
  } catch (error) {
    // localStorage may be unavailable (private mode / restricted browsers)
  }
};

/**
 * Prefer gclid from the current URL, then fall back to localStorage.
 */
export const getGclid = () => {
  try {
    return getGclidFromUrl() || localStorage.getItem(GCLID_STORAGE_KEY) || '';
  } catch (error) {
    return getGclidFromUrl() || '';
  }
};
